__turbopack_context__.v({
  "contentPadding": "partnerHeader-module-scss-module__MtH_1G__contentPadding",
  "contentPaddingSlim": "partnerHeader-module-scss-module__MtH_1G__contentPaddingSlim",
  "ctaContainer": "partnerHeader-module-scss-module__MtH_1G__ctaContainer",
  "dark": "partnerHeader-module-scss-module__MtH_1G__dark",
  "gradientBar": "partnerHeader-module-scss-module__MtH_1G__gradientBar",
  "header": "partnerHeader-module-scss-module__MtH_1G__header",
  "headerSlim": "partnerHeader-module-scss-module__MtH_1G__headerSlim",
  "lcLogo": "partnerHeader-module-scss-module__MtH_1G__lcLogo",
  "lcLogoContainer": "partnerHeader-module-scss-module__MtH_1G__lcLogoContainer",
  "light": "partnerHeader-module-scss-module__MtH_1G__light",
  "partnerContainer": "partnerHeader-module-scss-module__MtH_1G__partnerContainer",
  "partnerLogo": "partnerHeader-module-scss-module__MtH_1G__partnerLogo",
  "partnerLogoContainer": "partnerHeader-module-scss-module__MtH_1G__partnerLogoContainer",
  "partnerLogoText": "partnerHeader-module-scss-module__MtH_1G__partnerLogoText",
  "wrapper": "partnerHeader-module-scss-module__MtH_1G__wrapper",
});
